module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p10"
  }, [_vm._v("This book is for Robert Ivey, my father, who showed me there wasn’t anything I couldn’t do. His love for reading had no boundaries, and he made sure that I had none. Thank you for everything you’ve done for me and the pride you had in my writing by reading my first two books.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("I just wish you could read this one too.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c385e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/005.vue
// module id = 66
// module chunks = 0